import { useState } from "react";
import { X, FlaskConical, CheckCircle2 } from "lucide-react";
import { isBetaUser } from "@/lib/betaAccess";

const DISMISSED_KEY = "beta_banner_dismissed";

const BetaBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISSED_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const betaActive = isBetaUser();

  const handleDismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch {}
  };

  return (
    <div className="relative bg-accent/10 border-b border-accent/20 text-foreground">
      <div className="container max-w-5xl py-1.5 px-4 flex items-center gap-2">
        {betaActive ? (
          <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
        ) : (
          <FlaskConical className="h-4 w-4 text-accent shrink-0 mt-0.5" />
        )}
        <div className="flex-1 min-w-0">
          {betaActive ? (
            <p className="text-xs font-medium leading-snug text-primary">
              Beta Access Active ✅ — You have full access to all features.
            </p>
          ) : (
            <>
              <p className="text-xs font-medium leading-snug">
                <span className="font-semibold text-accent">Friends &amp; Family Beta:</span>{" "}
                Frog Knows Natives is currently being tested and improved. Some features may still change.
              </p>
              <p className="text-[10px] text-muted-foreground mt-0.5">
                Use the beta access code if one was shared with you.
              </p>
            </>
          )}
        </div>
        <button
          onClick={handleDismiss}
          className="shrink-0 p-1 rounded-md hover:bg-accent/10 transition-colors"
          aria-label="Dismiss beta notice"
        >
          <X className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
};

export default BetaBanner;
